import { Phone, MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

export const FloatingCTA = () => {
  const { pathname } = useLocation();
  // Hide on mobile when sticky bar is shown (program detail pages)
  const isProgramDetail = /^\/programs\/[^/]+/.test(pathname);
  const wrapperClass = isProgramDetail
    ? "hidden lg:flex fixed bottom-6 right-6 z-50 flex-col gap-3"
    : "fixed bottom-6 right-6 z-50 flex flex-col gap-3";
  return (
    <div className={wrapperClass} data-testid="floating-cta">
      <a
        href="https://wa.me/918308776505?text=Hi%2C%20I%27m%20interested%20in%20coaching%20at%20Vedanti%20Academy.%20Please%20share%20more%20details."
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="group relative w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg shadow-green-500/30 hover:shadow-xl hover:shadow-green-500/40 transition-all hover:scale-110"
        data-testid="floating-whatsapp-btn"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={26} className="text-white" />
        <span className="absolute right-full mr-3 bg-slate-900 text-white text-xs font-medium px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Chat on WhatsApp
        </span>
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-vedanti-mango rounded-full animate-ping"></span>
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-vedanti-mango rounded-full"></span>
      </a>
      <a
        href="tel:+918308776505"
        className="group relative w-14 h-14 bg-vedanti-orange hover:bg-vedanti-orange/90 rounded-full flex items-center justify-center shadow-lg shadow-orange-500/30 hover:shadow-xl hover:shadow-orange-500/40 transition-all hover:scale-110"
        data-testid="floating-call-btn"
        aria-label="Call Us"
      >
        <Phone size={24} className="text-white" />
        <span className="absolute right-full mr-3 bg-slate-900 text-white text-xs font-medium px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Call: +91 8308776505
        </span>
      </a>
    </div>
  );
};
